import React from "react"
import { createRoot } from "react-dom/client"
import { initSentry } from "./helpers/sentry"
import App from "./App"

// Initialise Sentry before anything else renders
initSentry()
import * as serviceWorker from "./serviceWorker"
import { BrowserRouter } from "react-router-dom"
import "./i18n"
import "react-toastify/dist/ReactToastify.css"
import { Provider } from "react-redux"

import store from "./store"

const app = (
  <Provider store={store}>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
    >
      <App />
    </BrowserRouter>
  </Provider>
)

const container = document.getElementById("root")
const root = createRoot(container)
root.render(app)
serviceWorker.unregister()
